import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const TabNavWrapper = styled.div`
  --ad-gap: 25px;

  position: relative;
  width: 100vw;
  height: 45px;
  padding: 0 15px;
  overflow: hidden;

  @media (min-width: 768px) {
    padding: 0 var(--ad-gap);
  }

  @media (min-width: 1024px) {
    width: 100%;
    padding: 0;

    [class*='MatchStatsTabWrapper'] & {
      padding: 0 var(--ad-gap);
    }

    [class*='MarketsWrapper'] & {
      width: 100vw;
      padding: 0 calc((100vw - 930px) / 2);
    }

    [data-takeovers='true'] [class*='MarketsWrapper'] & {
      width: 100%;
      padding: 0 calc((100% - 930px) / 2);
    }
  }

  @media (min-width: 1024px) and (max-width: 1200px) {
    --odds-button-width: 34px;
  }

  @media (min-width: 1200px) {
    width: 100%;

    [data-takeovers='true'] .expanded [class*='MarketsWrapper'] & {
      padding: 0 calc((100% - 930px) / 2);
    }
  }

  @media (min-width: 1281px) {
    --bookie-count: 24;
    --odds-button-width: 38px;

    [data-takeovers='true'] &,
    [data-takeovers='true'] .expanded & {
      width: 100%;
    }

    [class*='MarketsWrapper'] & {
      padding: 0 calc((100vw - 1000px) / 2);
    }

    [data-takeovers='true'] [class*='MarketsWrapper'] & {
      padding: 0 var(--ad-gap);
    }

    [data-takeovers='true'] .expanded [class*='MarketsWrapper'] & {
      padding: 0 calc((var(--max-width) - 1000px) / 2);
    }
  }

  @media (min-width: 1361px) {
    padding: 0;

    [class*='MarketsWrapper'] & {
      padding: 0 calc((100vw - 1200px) / 2);
    }

    [data-takeovers='true'] [class*='MarketsWrapper'] &,
    [class*='MatchStatsTabWrapper'] & {
      padding: 0 var(--ad-gap);
    }

    [data-takeovers='true'] .expanded [class*='MarketsWrapper'] & {
      padding: 0 calc(((max(var(--max-width), 1200px) - 1200px) / 2) + var(--ad-gap));
    }
  }
`;

export const TabNavWrapperInner = styled.div`
  height: 100%;
  margin: 0 -25px;
  overflow: hidden;

  @media (min-width: 1024px) {
    margin: 0 calc(-1 * ((100vw - 930px) / 2));
  }

  @media (min-width: 1281px) {
    margin: 0 calc(-1 * calc((100vw - 1000px) / 2));

    [data-takeovers='true'] & {
      margin: 0 calc(-1 * var(--ad-gap));
    }

    .expanded & {
      margin: 0 calc(-1 * ((100vw - 1000px) / 2));
    }
  }

  @media (min-width: 1361px) {
    margin: 0 calc(-1 * ((100vw - 1200px) / 2));

    .expanded & {
      margin: 0 calc(-1 * ((100vw - 1200px) / 2));
    }
  }
`;

export const TabNavScrollOuter = styled.div`
  -webkit-overflow-scrolling: touch;
  height: 100%;
  width: 100%;
  overflow-y: hidden;
`;

export const TabNavScrollInner = styled.div`
  height: 100%;
  overflow-y: hidden;
  white-space: nowrap;
  overflow-x: scroll;
  scroll-behavior: smooth;
  padding: 15px 0 45px;
  margin-bottom: -30px;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const TabWithScrollButtonsContainer = css`
  display: flex;
  margin: -15px 0 0;

  @media (min-width: 1024px) {
    margin: -15px 0 0;
  }

  @media (min-width: 1281px) {
    margin: -15px 0 0;

    [data-takeovers='true'] & {
      margin: -15px 0 0;
    }

    .expanded & {
      margin: -15px 0 0;
    }
  }

  @media (min-width: 1361px) {
    margin: -15px 0 0;

    .expanded & {
      margin: -15px 0 0;
    }
  }
`;

export const TabContainer = css`
  display: flex;
  margin: -15px 25px 0;

  @media (min-width: 1024px) {
    margin: -15px calc((100vw - 930px) / 2) 0;
  }

  @media (min-width: 1281px) {
    margin: -15px calc((100vw - 1000px) / 2) 0;

    [data-takeovers='true'] & {
      margin: -15px var(--ad-gap) 0;
    }

    .expanded & {
      margin: -15px calc((100vw - 1000px) / 2) 0;
    }
  }

  @media (min-width: 1361px) {
    margin: -15px calc((100vw - 1200px) / 2) 0;

    .expanded & {
      margin: -15px calc(((100vw - 1200px) / 2)) 0;
    }
  }
`;

export const styles = {
  pill: css`
    white-space: nowrap;
    padding: 6px 15px 7px;
    border-radius: 17px;
    border: solid 1px var(--oc-border);
    background-color: var(--oc-bg-grey);
    font-size: 14px;
    font-weight: 600;
    line-height: 1.36;
    margin-right: 10px;
    color: var(--oc-text-body);
    &:hover {
      border: solid 2px var(--oc-border);
      padding: 5px 14px 6px;
    }
    &.active {
      background-color: var(--oc-primary-green);
      border-color: var(--oc-primary-green);
      color: var(--oc-primary-white);
    }
  `,

  pillActive: css`
    background-color: var(--oc-primary-green);
    border-color: var(--oc-primary-green);
    color: var(--oc-primary-white);
    &:hover {
      border-color: var(--oc-primary-green);
    }
  `,

  tabNav: css`
    position: relative;
    font-family: var(--oc-font-family);
    cursor: pointer;
    scroll-snap-align: start;
  `,

  text: css`
    position: relative;
    padding: 12px 20px;
    font-size: 13px;
    font-weight: 800;
    line-height: 1.69;
    color: var(--oc-text-subtext);
    text-transform: uppercase;
    &:hover {
      &:after {
        content: '';
        position: absolute;
        right: 0;
        bottom: 1px;
        left: 0;
        height: 3px;
        background-color: var(--oc-border);
        border-radius: 2.5px;
      }
    }
  `,

  textActive: css`
    color: var(--oc-text-body);

    &:after {
      content: '';
      position: absolute;
      right: 0;
      bottom: 1px;
      left: 0;
      height: 3px;
      background-color: var(--oc-primary-green);
      border-radius: 2.5px;
    }

    &:hover {
      &:after {
        background-color: var(--oc-primary-green);
      }
    }
  `,
};

export const ToolBarItemContainer = styled.div`
  position: relative;
  overflow: visible;
  display: flex;
  align-items: flex-end;

  &:last-of-type {
    padding-right: 15px;
  }

  @media (min-width: 1024px) {
    &:last-of-type {
      padding-right: calc(((100vw - 930px) / 2) - 10px);
    }
  }

  @media (min-width: 1281px) {
    &:last-of-type {
      padding-right: 15px;
    }

    .expanded & {
      &:last-of-type {
        padding-right: calc(((var(--max-width) - 1000px) / 2) - var(--ad-gap));
      }
    }
  }

  @media (min-width: 1361px) {
    &:last-of-type {
      padding-right: 15px;
    }

    .expanded & {
      &:last-of-type {
        padding-right: calc(((100vw - 1200px) / 2) - 10px);
      }
    }
  }
`;

export const ScrollToolBarItemContainer = styled.div`
  position: relative;
  overflow: visible;
  display: flex;
  align-items: flex-end;
`;

export const ToolbarItemWithNewIcon = css`
  height: 45px;
`;

export const WrapperWithNewIcon = css`
  transform: translateY(-11px);
`;
